import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DocumentDownloadService } from '../../services/document-download.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-download-file-button',
  templateUrl: './download-file-button.component.html',
  styleUrls: ['./download-file-button.component.scss']
})
export class DownloadFileButtonComponent implements OnInit, OnDestroy {
  @Input() documentId!: number;
  @Input() fileName!: string;
  @Input() buttonText: string = 'Скачать документ';

  isDownloading: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private documentDownloadService: DocumentDownloadService) {}

  ngOnInit(): void {
    this.documentDownloadService
      .getDownloadState(this.documentId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.isDownloading = state.isDownloading;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async downloadDocument(): Promise<void> {
    await this.documentDownloadService.downloadDocument(
      this.documentId,
      this.fileName
    );
  }
} 